import { useState, MouseEvent, memo } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Menu, MenuItem } from '@mui/material'
import { WaterlineChild } from './types'
import { exportAllResults, exportResultsByPractice, exportLastResults } from './utils/exports'

type WaterlineExportButtonProps = {
  corpChildren: WaterlineChild[] | null,
}

const WaterlineExportButton = (props: WaterlineExportButtonProps) => {
  const { corpChildren } = props

  const [exportOpenEl, setExportOpenEl] = useState<EventTarget & HTMLButtonElement | null>(null)
  
  const handleExportClose = () => {
    setExportOpenEl(null)
  }

  const handleExportClick = (event: MouseEvent<HTMLButtonElement>) => {
    setExportOpenEl(event.currentTarget)
  }

  const exportOpen = Boolean(exportOpenEl)

  const handleAllResults = () => {
    handleExportClose()
    exportAllResults(corpChildren)
  }

  const handleResultsByPractice = () => {
    handleExportClose()
    exportResultsByPractice(corpChildren)
  }

  const handleLastResults = () => {
    handleExportClose()
    exportLastResults(corpChildren)
  }

  return (
    <div className="dropdown">
      <Button
        id="export-button"
        className='m-r-12'
        aria-haspopup="true"
        variant="contained"
        name="export"
        onClick={handleExportClick}
      >
        Export
        <FontAwesomeIcon icon="caret-down" size="sm" className="m-l-8" />
      </Button>
      <Menu
        id="account-menu"
        anchorEl={exportOpenEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        open={exportOpen}
        onClose={handleExportClose}
        MenuListProps={{
          'aria-labelledby': 'export-button'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <MenuItem onClick={handleAllResults}>
          All Results
        </MenuItem>
        <MenuItem onClick={handleResultsByPractice}>
          Results by Practice
        </MenuItem>
        <MenuItem onClick={handleLastResults}>
          Last Test Results
        </MenuItem>
      </Menu>
    </div>
  )
}

function arePropsEqual(prevProps: Readonly<WaterlineExportButtonProps>, newProps: Readonly<WaterlineExportButtonProps>) {
  return prevProps.corpChildren?.length === newProps.corpChildren?.length
}

export default memo(WaterlineExportButton, arePropsEqual)
